import request from "@/util/request.js";
import qs from 'query-string';

export default{
    get(url,params){
        if(typeof(params)!="object"){
            var datas=params
        }else{
            var datas=qs.stringify(params)
        }
        return request({
            url: url,
            method: 'get',
            data: datas,
        });
    },
    download(url,params){
        return request({
            url: url,
            method: 'get',
            responseType: 'blob',
            data: qs.stringify(params),
        });
    },
    post(url,params){
        return request({
            url: url,
            method: 'post',
            data:params,
        });
    },
    put(url,params){
        return request({
            url: url,
            method: 'put',
            data:params,
        });
    },

    delete(url,params){
        return request({
            url: url,
            method: 'delete',
            data: params,
        });
    }
}


